import baseConfigs from './base';

export default {
  ...baseConfigs,
};
